module.exports = __webpack_public_path__ + "img/sertificati.ca4186a3.svg";